import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">WAYS TO IMPROVE YOUR IMPACT ON OTHERS</span>
                                            </div>
                                            <div className="border_subtitle">Matching their body language</div>
                                            <p>This can be done to build rapport and many people do it naturally
                                                to ensure they blend or fit in. It can include adopting a
                                                similar posture, giving the same amount of eye contact and
                                                matching others’ hand gestures in speed and frequency. The
                                                intention behind body matching is to share and understand the
                                                other person’s experience of the world, as how we use our body
                                                influences our emotional state. Although these factors are
                                                subtle they are attended to by us and others, even if
                                                subconsciously, and will affect our impact on others.</p>
                                            <div className="border_subtitle">Voice matching</div>
                                            <p>Again we naturally adapt our voice in volume and pace to that of
                                                others. For example, when dealing with someone who is really
                                                passionate about something, this can be catching and we can feel
                                                excited and passionate about it also. The converse is true when
                                                dealing with people who are angry, where we can match them
                                                slightly below their level of volume and speed. Then we can
                                                influence them by gradually lowering our own voice or slowing
                                                the pace and this can lead to them doing the same.</p>
                                            <div className="border_subtitle">Mismatching</div>
                                            <p>This is the opposite of matching and is a useful skill. It aims
                                                to be disengaging and can be used to bring the discussion to a
                                                close. It need not invalidate the other person or their
                                                view. </p>
                                            <div className="border_subtitle">Cross-over matching</div>
                                            <p>This involves less concentration and focus than matching, as we
                                                would match the other person’s body language with a different
                                                type of movement; for example, tapping a foot in time to their
                                                rhythm of speech. Again this can help build our non-verbal
                                                relationship with the person and can be used to calm or slow the
                                                situation subconsciously. </p>
                                            <p>These factors will further enhance your understanding of the
                                                impact your behaviour and actions have on others and how you can
                                                adapt your style to improve your own impact.</p>
                                            <p>Creating a positive impact is something that requires a fairly
                                                high level of self-awareness. You should try to gain the views
                                                of people around you and identify the impact of your behaviour
                                                in different situations. Principally you need to understand the
                                                impact of your approach on other people, in order to make a
                                                positive difference.</p>
                                            <p>Continual feedback is needed to help you understand your impact
                                                on others. There are a number of ways to ensure that what you
                                                intended and the reality of your impact are aligned. These
                                                include:</p>

                                            <ul className="greenbullet-list">
                                                <li>Request to have 360 degree feedback to understand the
                                                    perspectives of those around you.
                                                </li>
                                                <li>Have regular and informal feedback sessions.</li>
                                                <li style={{paddingBottom:'9px !important'}}>Create a clear
                                                    development plan to improve your impact in progressively
                                                    difficult situations, or with difficult individuals.
                                                </li>

                                            </ul>
                                            <div className="lightgreencontentbg keyquestionpad paraspace">
                                                <div className="border_subtitle">Critical factors in creating a
                                                    positive impact
                                                </div>
                                                <p><span className="subtiltereg">Flexibility</span></p>
                                                <div><p style={{paddingBottom:'0px !important'}}>It is crucial
                                                    that you are able to listen to and observe the individual
                                                    vigilantly. Pay particular attention to the situation and
                                                    try to see it from their perspective.</p></div>

                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }